import PrivateRoute from '@/components/PrivateRoute.tsx';
import ActivatePage from '@/pages/auth/activate';
import AuthLayout from '@/pages/auth/AuthLayout.tsx';
import Login from '@/pages/auth/login';
import PasswordResetPage from '@/pages/auth/password-reset';
import FeedsPage from '@/pages/feeds';
import FeedEditorPage from '@/pages/feeds/Editor';
import FilesPage from '@/pages/files';
import FileEditorPage from '@/pages/files/Editor.tsx';
import Home from '@/pages/Home.tsx';
import ProvidersPage from '@/pages/providers';
import ScriptsPage from '@/pages/scripts';
import ScriptEditorPage from '@/pages/scripts/Editor';
import {OverlaysProvider} from '@blueprintjs/core';
import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {createBrowserRouter, createRoutesFromElements, Route, RouterProvider} from 'react-router';
import {Layout} from './Layout.tsx';

let container = document.getElementById('app')!;
let root = createRoot(container);

const router = createBrowserRouter(createRoutesFromElements(
	<>
		<Route element={<AuthLayout />}>
			<Route path="/login" element={<Login />} />
			<Route path="/activate" element={<ActivatePage />} />
			<Route path="/reset-password" element={<PasswordResetPage />} />
		</Route>

		<Route element={<PrivateRoute><Layout /></PrivateRoute>}>
			<Route index={true} element={<Home />} />

			<Route path="feeds" element={<FeedsPage />} />
			<Route path="feeds/:id" element={<FeedEditorPage />} />

			<Route path="files" element={<FilesPage />} />
			<Route path="files/:id" element={<FileEditorPage />} />

			<Route path="scripts" element={<ScriptsPage />} />
			<Route path="scripts/:id" element={<ScriptEditorPage />} />

			<Route path="providers" element={<ProvidersPage />} />
		</Route>
	</>,
));

root.render(
	<StrictMode>
		<OverlaysProvider>
			<RouterProvider router={router} />
		</OverlaysProvider>
	</StrictMode>,
);
